import {
    GET_GATICKET_LOADING, GATICKET_DATA_SUCCESS, GATICKET_DATA_ERROR,
    GATICKETDISPLAYAREA_DATA_SUCCESS, GATICKET_UPDATE_QUANTITY
} from "../actions/actionGATicket";
import { loadState, saveState } from "../helpers/sessionStorage";

import { genfunction } from 'helpers';

const sessionKey = "GATickets_View";

const initialState = {
    GATickets: loadState(sessionKey, []),
    loading: false,
    GATicketsError: '',
    GADisplayAreas: []
};

function reducerGaTicket(state = initialState, action) {

    switch (action.type) {
        case GET_GATICKET_LOADING: {
            return {
                ...state,
                loading: true
            };
        }


        case GATICKET_DATA_SUCCESS: {

            let newGATickets = action.payload.map(obj => ({ ...obj, Quantity: 0, TicketAmount: 0, TaxAmount: 0, TotalAmount: 0 }))
            let oldGATickets = state.GATickets.filter(oldticket => {
                let existticket = newGATickets.find(newticket => newticket.ProductID == oldticket.ProductID);
                if (existticket == undefined)
                    return true;
            });

            saveState(sessionKey, [...newGATickets, ...oldGATickets]);
            return {
                ...state,
                GATickets: [...newGATickets, ...oldGATickets],
                loading: false,
                GATicketsError: ''
            };
        }

        case GATICKETDISPLAYAREA_DATA_SUCCESS: {
            return {
                ...state,
                GADisplayAreas: action.payload,
            };
        }

        case GATICKET_UPDATE_QUANTITY: {
            let oldticketstate = [
                ...state.GATickets
            ]
            let gatickets = oldticketstate.map(obj => {
                let ticket = { ...obj };
                if (ticket.ProductID === action.payload.ProductID) {
                    ticket.Quantity = action.payload.Quantity;
                }
                return ticket;
            })

            gatickets = genfunction.calculategaticketamount(gatickets);

            return {
                ...state,
                GATickets: gatickets,
            };
        }

        case GATICKET_DATA_ERROR: {

            let error = "";
            if (action.error.Errors) {
                error = action.error.Errors[0].ErrorMessage
            }
            else
                error = action.error.message;

            return {
                ...state,
                loading: false,
                GATickets: [],
                GATicketsError: error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerGaTicket;